export const FALLBACK = '-'

const clean = (v: any) => {
  if (v === null || v === undefined) return undefined
  const s = String(v).trim()
  return s.length ? s : undefined
}

const toDateOnly = (v: any) => {
  const s = clean(v)
  if (!s) return undefined
  return s.includes('T') ? s.split('T')[0] : s
}

const pick = (...vals: any[]) => vals.map(clean).find(Boolean)

const addIf = (arr: any[], value: any, label: string) => {
  const v = clean(value)
  if (v) arr.push({ name: v, label })
}

type OrderRowA = {
  id: number
  orderNumber: number
  supplierName?: string
  supplierCode?: number
  shopCode?: string
  rayonName?: string
  dsDeliveryStatusValue?: string
  orderStatusDescription?: string
  orderDate?: string
  deliveryDate?: string
  expectedDeliveryDate?: string
  deliveryHour?: string
  temperatureComplaint?: boolean
  arrivalTemperature?: any
  noticeNumber?: number
}

type OrderRowB = {
  id: number
  orderId?: number
  orderNumber?: number
  supplierName?: string
  supplierCode?: number
  shopCode?: string
  integrationStatusValue?: string
  created?: string
  sentTime?: string
  hasDifference?: boolean
  hasError?: boolean
}

type OrderRowUnion = Partial<OrderRowA & OrderRowB>

export function buildOrderInfoItems(row?: OrderRowUnion) {
  const items: { name: string; label: string }[] = []
  if (!row) return items

  addIf(items, pick(row.orderNumber), 'Număr comandă:')
  addIf(items, pick(row.orderId, row.id), 'ID comandă:')

  addIf(items, row.shopCode, 'Magazin(e):')
  addIf(items, row.supplierName, 'Nume Furnizor:')
  addIf(items, row.supplierCode, 'Cod furnizor:')

  addIf(
    items,
    pick(row.dsDeliveryStatusValue, row.orderStatusDescription, row.integrationStatusValue),
    'Status:'
  )

  addIf(items, toDateOnly(pick(row.orderDate, row.created)), 'Data înregistrare:')
  addIf(items, toDateOnly(pick(row.deliveryDate)), 'Data expediție:')
  addIf(items, toDateOnly(pick(row.expectedDeliveryDate)), 'Data livrare estimată:')

  addIf(items, clean(row.rayonName), 'Raion:')
  addIf(items, clean(row.noticeNumber), 'Nr. aviz:')

  if (row.temperatureComplaint !== undefined) {
    addIf(items, row.temperatureComplaint ? 'Da' : 'Nu', 'Conformitate temperatură:')
  }

  return items
}
